'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../../../../util');

var _util2 = _interopRequireDefault(_util);

var _checkbox = require('../../../../checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _button = require('../../../../button');

var _button2 = _interopRequireDefault(_button);

var _lodashCompat = require('lodash-compat');

var _multiSelectDropdown = require('../multi-select-dropdown');

var _multiSelectDropdown2 = _interopRequireDefault(_multiSelectDropdown);

var _icon = require('../../../../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var MultiSelectFilter = function (_M$BaseComponent) {
  _inherits(MultiSelectFilter, _M$BaseComponent);

  function MultiSelectFilter(props) {
    _classCallCheck(this, MultiSelectFilter);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MultiSelectFilter).call(this, props));

    var model = props.model;

    var _ref = model || {};

    var filteredFullValue = _ref.filteredFullValue;
    var filters = _ref.filters;
    var filterModel = _ref.filterModel;
    //如果有传入onFetchData，则默认不使用filters的数据

    var data = (0, _lodashCompat.isFunction)(filterModel.onFetchData) ? [] : (0, _lodashCompat.isArray)(filters) ? filters.slice() : [];
    Object.assign(_this.state, {
      data: data,
      showData: _this._getShowData(data, filterModel),
      selectedKeys: (filteredFullValue || []).map(function (v) {
        return v.value;
      }),
      loading: false,
      showSearch: filterModel.showSearch, //是否显示搜索框
      value: filteredFullValue || []
    });
    //FIXME 是否统一处理组件值，目前：selectedKeys是无搜索框，由本组件实现的；value是嵌入了MultiSelectDropdown
    return _this;
  }

  _createClass(MultiSelectFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //如果不显示搜索框，则在组件刚加载时获取数据
      if (!this.state.showSearch) {
        this._onFetchData();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var model = nextProps.model;

      var _ref2 = model || {};

      var filteredFullValue = _ref2.filteredFullValue;
      var value = this.state.value;

      this.setState({
        selectedKeys: (filteredFullValue || []).map(function (v) {
          return v.value;
        }),
        value: (0, _lodashCompat.isArray)(filteredFullValue) && filteredFullValue.length == 0 ? [] : value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var model = this.props.model;

      var _ref3 = model || {};

      var filterModel = _ref3.filterModel;

      var _ref4 = filterModel || {};

      var type = _ref4.type;

      var m = _objectWithoutProperties(_ref4, ['type']);

      var _state = this.state;
      var showData = _state.showData;
      var selectedKeys = _state.selectedKeys;
      var showSearch = _state.showSearch;
      var loading = _state.loading;
      var value = _state.value;

      var baseCls = 'multi-select-filter';
      //显示搜索框时，loading状态由内部决定
      if (showSearch) {
        //FIXME 过滤传入select的参数
        var selectProps = _extends({}, m, {
          model: (0, _lodashCompat.pick)(m, ['idField', 'showField', 'tpl', 'showTpl', 'format']),
          onFetchData: this._onFetchData,
          size: 'small'
        });
        return _react2.default.createElement(
          'div',
          { className: baseCls },
          _react2.default.createElement(_multiSelectDropdown2.default, { selectProps: selectProps,
            type: type,
            value: value,
            onCancel: this._onCancel,
            onConfirm: this._onConfirm })
        );
      } else {
        var listItems = void 0;
        if (loading) {
          listItems = _react2.default.createElement(
            'li',
            { className: baseCls + '__loading' },
            _react2.default.createElement(_icon2.default, { className: baseCls + '__loading-icon', type: 'loading' })
          );
        } else if (!showData || showData.length == 0) {
          return null;
        } else {
          listItems = (showData || []).map(function (d, i) {
            var value = d.value;
            var label = d.label;

            var checked = selectedKeys.includes(value);
            return _react2.default.createElement(
              'li',
              { key: i,
                className: _util2.default.classNames(baseCls + '__item', {
                  active: checked
                }) },
              _react2.default.createElement(
                _checkbox2.default,
                { className: baseCls + '__item-checkbox',
                  size: 'small',
                  checked: checked,
                  onChange: _this2._onSelect.bind(_this2, value),
                  domProps: { title: label } },
                label
              )
            );
          });
        }
        return _react2.default.createElement(
          'div',
          { className: baseCls },
          _react2.default.createElement(
            'ul',
            { className: baseCls + '__list' },
            listItems
          ),
          _react2.default.createElement(
            'div',
            { className: baseCls + '__operation' },
            _react2.default.createElement(_button2.default, { className: baseCls + '__btn reset-btn',
              type: 'default',
              shape: 'no-outline',
              size: 'small',
              label: '重置',
              onClick: this._onReset }),
            _react2.default.createElement(_button2.default, { className: baseCls + '__btn confirm-btn',
              type: 'primary',
              shape: 'no-outline',
              size: 'small',
              label: '确定',
              onClick: this._onConfirm })
          )
        );
      }
    }
  }, {
    key: '_onSelect',
    value: function _onSelect(key, e) {
      var checked = e.target.checked;
      var selectedKeys = this.state.selectedKeys;

      var index = selectedKeys.indexOf(key);
      if (index == -1 && checked) {
        selectedKeys.push(key);
      } else if (index != -1 && !checked) {
        selectedKeys.splice(index, 1);
      }
      this.setState({ selectedKeys: selectedKeys });
    }
  }, {
    key: '_onReset',
    value: function _onReset() {
      this.setState({ selectedKeys: [] });
    }
  }, {
    key: '_onConfirm',
    value: function _onConfirm(value) {
      var _this3 = this;

      var showSearch = this.state.showSearch;

      if (showSearch) {
        this.setState({
          value: value
        }, function () {
          var onConfirm = _this3.props.onConfirm;

          onConfirm && onConfirm(value);
        });
      } else {
        (function () {
          var onConfirm = _this3.props.onConfirm;
          var _state2 = _this3.state;
          var selectedKeys = _state2.selectedKeys;
          var showData = _state2.showData;

          onConfirm && onConfirm(showData.filter(function (d) {
            return selectedKeys.includes(d.value);
          }));
        })();
      }
    }
  }, {
    key: '_onCancel',
    value: function _onCancel() {
      var onCancel = this.props.onCancel;

      onCancel && onCancel();
    }
  }, {
    key: '_onFetchData',
    value: function _onFetchData(filter, callback) {
      return new Promise(function ($return, $error) {
        var _this4 = this;

        var showSearch = this.state.showSearch;

        function $IfStatement_3() {
          return $return();
        }

        if (showSearch) {
          var _ret2 = function () {
            var $IfStatement_4 = function $IfStatement_4() {
              return $IfStatement_3.call(this);
            };

            var filterModel = _this4.props.model.filterModel;
            var onFetchData = filterModel.onFetchData;

            if ((0, _lodashCompat.isFunction)(onFetchData)) {
              return {
                v: Promise.resolve(onFetchData(filter)).then(function ($await_6) {
                  var res = $await_6;
                  this.setState({
                    data: res,
                    showData: this._getShowData(res, filterModel)
                  }, (0, _lodashCompat.isFunction)(callback) && callback.bind(this, res));
                  return $IfStatement_4.call(_this4);
                }.$asyncbind(_this4, $error), $error)
              };
            }
            return {
              v: $IfStatement_4.call(_this4)
            };
          }();

          if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
        } else {
          var $Try_1_Finally;
          var $Try_1_Catch;

          var _ret3 = function () {
            var $IfStatement_5 = function $IfStatement_5() {
              return $IfStatement_3.call(this);
            };

            var filterModel = _this4.props.model.filterModel;
            var onFetchData = filterModel.onFetchData;

            if ((0, _lodashCompat.isFunction)(onFetchData)) {
              var _ret4 = function () {
                var $Try_1_Post = function $Try_1_Post() {
                  return $IfStatement_5.call(_this4);
                };

                $Try_1_Finally = function ($Try_1_Exit) {
                  return function ($Try_1_Value) {
                    this.setState({ loading: false });
                    return $Try_1_Exit && $Try_1_Exit.call(this, $Try_1_Value);
                  }.$asyncbind(this, $error);
                }.$asyncbind(_this4);

                $Try_1_Catch = function ($exception_2) {
                  return $Try_1_Finally($error)($exception_2);
                }.$asyncbind(_this4, $Try_1_Finally($error));

                try {
                  _this4.setState({ loading: true });
                  return {
                    v: {
                      v: Promise.resolve(onFetchData()).then(function ($await_7) {
                        var res = $await_7;
                        if (res) {
                          this.setState({
                            data: res,
                            showData: this._getShowData(res, filterModel)
                          });
                        }
                        return $Try_1_Finally($Try_1_Post).call(this);
                      }.$asyncbind(_this4, $Try_1_Catch), $Try_1_Catch)
                    }
                  };
                } catch ($exception_2) {
                  $Try_1_Catch($exception_2)
                }
              }();

              if ((typeof _ret4 === 'undefined' ? 'undefined' : _typeof(_ret4)) === "object") return _ret4.v;
            }
            return {
              v: $IfStatement_5.call(_this4)
            };
          }();

          if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
        }
      }.$asyncbind(this));
    }
  }, {
    key: '_getShowData',
    value: function _getShowData(data, model) {
      var idField = model.idField;
      var showField = model.showField;

      return (data || []).map(function (d) {
        return _extends({}, d, { label: d[showField], value: d[idField] });
      });
    }
  }]);

  return MultiSelectFilter;
}(_util2.default.BaseComponent);

exports.default = MultiSelectFilter;